const themeMap = {
  light: {
    backgroundColour: '#ECEFF1',
    foregroundColour: '#1E4F67',
    reversed: false
  },
  white: {
    backgroundColour: '#FFFFFF',
    foregroundColour: '#1E4F67',
    reversed: false
  },
  dark: {
    backgroundColour: '#5B6770',
    foregroundColour: '#ECEFF1',
    reversed: true
  },
  blue: {
    backgroundColour: '#1E4F67',
    reversed: true
  }
}

export default themeMap
